export function getType(state, patch) {
    return state.types?.[patch.op];
}
export function getTypeLike(state, patch) {
    return state.types?.[patch.op]?.like;
}
